import Link from 'next/link'
import { Container } from './Container'
import { Logo } from './Logo'
import { Button } from '@/components/controls/Button'
import { Arrow } from './Arrow'

export function FooterSecDark({
  className = ''
}) {
  return (
    <footer className={`${className} bg-black text-white relative`}>
      <Container>
        <div className="flex md:items-center justify-between pt-[60px] md:pt-[120px] pb-[60px] md:py-[78px]">
          <div className="scale-[0.8] md:scale-[1] origin-left h-full md:h-auto">
            <Logo color="white"/>
            <p className="text-[13.5px] font-thin">Commit Action © 2024</p>
          </div>
          <ul className="flex flex-col md:flex-row text-[18px] md:text-[15px] font-thin">
            <li className="mx-[15px] mb-[20px] md:mb-0"><Link href="#whats-inside" passHref>What’s Inside?</Link></li>
            <li className="mx-[15px] mb-[20px] md:mb-0"><Link href="#whos-this-for" passHref>Who’s This For?</Link></li>
            <li className="mx-[15px] mb-[20px] md:mb-0"><Link href="#your-tutor" passHref>Your Tutor</Link></li>
            <li className="mx-[15px] mb-[20px] md:mb-0"><Link href="#testimonials" passHref>Testimonials</Link></li>
            <li className="mx-[15px]"><Link href="#faq" passHref>FAQ</Link></li>
          </ul>
          <div className="hidden md:block">
            <Button href={'#'} type="third" chevron={false} disableArrow={true} noWrap={true} fullWidth={true} maxWidth={350} uppercase={false}>Back To Start <Arrow className="ml-[10px] !scale-[0.8] !rotate-[180deg]"/></Button>
          </div>
        </div>
      </Container>
      <div className="md:hidden flex justify-center pb-[30px]">
        <Button href={'#'} type="third" chevron={false} disableArrow={true} noWrap={true} fullWidth={true} maxWidth={350} uppercase={false}>Back To Start <Arrow className="ml-[10px] !scale-[0.8] !rotate-[180deg]"/></Button>
      </div>
    </footer>
  )
}
